import React, {useEffect, useState} from "react";
import { Button, Column, Columns, Input, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";
import ApproveModalRow from "./ApproveModalRow";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {addXeroVat} from "../../utils";


export default function ApprovalModal({selectedTransaction, show, setShow, onApprove, getFilteredData, endpoint,
                                          validator, setGetFilteredData, paymentTypes, paymentTypeObjects,
                                          onSave, dataFresh, trackingOptions, trackingOptionObjects, type, nominalCodes, nominalCodeObjects}){
    let [filteredTransactions, setFilteredTransactions] = useState({results: []});
    const dispatch = useDispatch();

    const onChange = (e, index) => {
        let newTransaction = {...filteredTransactions.results[index]};
        newTransaction[e.target.name] = e.target.value;

        let newTransactions = [...filteredTransactions.results];
        newTransactions[index] = newTransaction;

        setFilteredTransactions({results: newTransactions});
    }

    const handleSave = (e, index, setEditable) => {
        let data = filteredTransactions.results[index];
        onSave(false, data).then(res => {
            setEditable(false);
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving a transaction", {position: "top-right"});
        });
    }

    const requestFilteredData = () => {
        if(selectedTransaction && selectedTransaction.invoice_number && selectedTransaction.department) {
            let url = endpoint + `transactions?inv=${selectedTransaction.invoice_number}&department=${selectedTransaction.department.id}&page_size=1000`;
            const conf = {
                url: url,
                method: "get"
            }
            axios(conf).then(res => {
                setFilteredTransactions(res.data)
            })
        }
    }
    useEffect(() => {
        requestFilteredData();
    }, [getFilteredData]);


    const approveAll = (e) => {
        let allValid = true;
        filteredTransactions.results.forEach(transaction => {
            allValid = allValid && validator(transaction)
        })
        if(allValid) {
            // filteredTransactions.results.forEach(transaction => {
            //     onApprove(e, true, transaction)
            // })
            onApprove(e, true, filteredTransactions.results).then(res => {
                setShow(false);
            })
        }
    }


    const getTotal = () => {
        let total = filteredTransactions.results.reduce((prev, current) => {
            return parseFloat(prev) + parseFloat(addXeroVat(current.invoice_vat, current.invoice_amount))
        }, 0)
        return total.toFixed(2);
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={show}
            onClose={() => {
                setShow(false);
                setGetFilteredData(undefined);
            }}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Transaction Approve</Title>
                        </Column>
                        <Column>
                            <label className="label">Department</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={selectedTransaction.department ? selectedTransaction.department.name: ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Total Invoice Amount</label>
                            <Input
                                disabled={true}
                                value={getTotal()}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Description</th>
                                        <th>Contact</th>
                                        <th>Tracking Category</th>
                                        <th>Payment Type</th>
                                        {type === "IN" &&<th>Customer Account</th>}
                                        <th>Nominal Code</th>
                                        <th>Invoice Amount</th>
                                        <th>Invoice VAT (%)</th>
                                        <th>Invoice Total</th>
                                        {type === "IN" && <th>Customer Paid</th>}
                                        <th>Invoice Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTransactions.results.map((transaction, index) => (
                                        <ApproveModalRow
                                            transaction={transaction}
                                            paymentTypes={paymentTypes}
                                            paymentTypeObjects={paymentTypeObjects}
                                            onSave={handleSave}
                                            onChange={onChange}
                                            index={index}
                                            trackingOptions={trackingOptions}
                                            trackingOptionObjects={trackingOptionObjects}
                                            nominalCodes={nominalCodes}
                                            nominalCodeObjects={nominalCodeObjects}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setGetFilteredData(undefined);
                                    setShow(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={approveAll}
                                isFullWidth
                            >
                                Approve
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}